<div class="dashboard-wrapper">
  <h2 class="heading">PRICE VOLUME PROFIT TOOL</h2>
  <div class="nav-wrapper common-width">
    <ng-container *ngFor="let nav of navItems">
      <div
        [ngClass]="{
          disabled: nav.disabled,
          relative_left: nav.name === 'REPORTING',
          relative_right: nav.name === 'PRICE BRACKET'
        }"
        (click)="redirect(nav.route)"
        class="item"
      >
        <div class="name bold-big-header-montserrat">
          <img
            style="margin-right: 5px"
            src="../../assets/IMP PVP Tool Icons/coke.svg"
            alt=""
          />
          {{ nav.name }}
          <mat-icon style="font-size: 15px; margin-top: 8px">
            arrow_forward_ios
          </mat-icon>
        </div>
        <img
          style="align-self: flex-end"
          [src]="'../../assets/IMP PVP Tool Icons/' + nav.img"
          height="60%"
          width="100%"
          alt=""
        />
        <div class="description small-text-montserrat">
          {{ nav.description }}
        </div>
      </div>
    </ng-container>
  </div>
</div>
